/**
 * Adds filter parameters to an existing url that leads to listing page
 *
 * @param {string} href
 * @param {array} activeFilters
 * @returns {string}
 */
export const persistFilters = (href, activeFilters) => {
    const paramFilters = {};
    let queryString = '?';

    if (typeof href === 'undefined' || href[0] === '#' || activeFilters.length <= 0) {
        return href;
    }

    activeFilters.forEach((filterItem) => {
        let tempFilterType = filterItem.filterType;

        if (tempFilterType.indexOf('tag-') !== -1) {
            tempFilterType = 'tag';
        }

        paramFilters[tempFilterType] = paramFilters[tempFilterType] || [];
        paramFilters[tempFilterType].push(filterItem.value);
    });

    const params = Object.keys(paramFilters)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(paramFilters[key].join())}`);

    if (params.length > 0) {
        queryString += params.join('&');
    }

    const linkArray = href.split('#');
    const linkHash = linkArray[1];
    const linkWithoutHash = linkArray[0];

    const hash = linkHash ? `#${linkHash}` : '';
    const link = linkWithoutHash.split('?')[0];

    return link + queryString + hash;
};
